export enum CommentType {
  Comment = 1,
  Suggestion = 2,
}
